// @ts-nocheck
import React from "react";
import { ReactComponent as RewardPointGrowthIcon } from "../../assets/reward-growth-icon-history-large.svg";
import rewardPointsStarIcon from "../../assets/reward-points-golden-star.svg";
import { Button, Spin } from "antd";
import NoPermissionComponent from "modules/kudos-user/component/NoPermissionComponent";

const RewardSystemEarnMoreView = (props) => {
  const { activityList, loading, permission, navigateRoute } = props;
  return (
    <Spin spinning={loading}>
      {
        permission && activityList.length ? <div className="reward-earnmore-root">
          <div className="reward-earnmore-container">
            <div className="reward-earnmore-hint">
              Complete these activities to earn more reward points
            </div>
            <div className="reward-earnmore-list-row">
              {activityList.map(({ title, points, path }, i) => (
                <div className="reward-earnmore-list-item" key={i}>
                  <div className="reward-earnmore-item-left">
                    <div className="reward-earnmore-circle">
                      <RewardPointGrowthIcon />
                    </div>
                    <div className="reward-earnmore-item-details">
                      <div className="reward-earnmore-item-title">{title}</div>
                      <div className="reward-earnmore-item-points">
                        <img src={rewardPointsStarIcon} alt="" />
                        {`Earn ${points} points`}
                      </div>
                    </div>
                  </div>
                  <Button className="reward-earnmore-item-button" onClick={() => { navigateRoute(path) }}>Start</Button>
                </div>
              )
              )}
            </div>
          </div>
        </div>
          : !loading && permission && <div className="no-activities-container">
            All rewards achieved
          </div>
      }
      {
        !loading && !permission && (
          <NoPermissionComponent />
        )
      }
    </Spin>
  )
}
export default RewardSystemEarnMoreView;